import {Injectable} from '@angular/core';
import {LoginResponse} from '../models/users';
import {Token} from '../models/token';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoragePortalService {

  private static readonly TOKEN_KEY = `${environment.storagePrefix}:token`;
  private static readonly CURRENT_USER_KEY = `${environment.storagePrefix}:currentUser`;

  private readonly storage: Storage;

  constructor() {
    this.storage = localStorage;
  }

  set currentUsuario(user: LoginResponse) {
    this.storage.setItem(StoragePortalService.CURRENT_USER_KEY,
      JSON.stringify(user));
  }

  get currentUsuario(): LoginResponse | null {
    const str = this.storage.getItem(StoragePortalService.CURRENT_USER_KEY);
    return str ? JSON.parse(str) : null;
  }

  clearCurrentUsuario() {
    this.storage.removeItem(StoragePortalService.CURRENT_USER_KEY);
  }


  get token(): Token | null {
    const raw = this.storage.getItem(StoragePortalService.TOKEN_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      this.clearToken();
      return null;
    }
  }

  set token(token: Token) {
    this.storage.setItem(StoragePortalService.TOKEN_KEY, JSON.stringify(token));
  }

  clearToken() {
    this.storage.removeItem(StoragePortalService.TOKEN_KEY);
  }


}
